module.exports = __webpack_public_path__ + "media/images/badges/bft/milestone-750-inactive-bft-0a9927bb447e8cb6e4e3e033317b7229.png";